var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWorkInProgressIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_67137_11926)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.9498 10.45C19.308 10.45 19.6669 10.3133 19.9396 10.0399L23.8997 6.07979C24.4466 5.53357 24.4466 4.64697 23.8997 4.1001C23.3529 3.55322 22.4656 3.55322 21.92 4.1001L17.96 8.06018C17.4131 8.6064 17.4131 9.49365 17.96 10.0399C18.2327 10.3134 18.5915 10.45 18.9498 10.45Z",
    fill: "#22C55E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5996 12.6001H20.9996C20.2264 12.6001 19.5996 13.227 19.5996 14.0001C19.5996 14.7733 20.2264 15.4001 20.9996 15.4001H26.5996C27.3728 15.4001 27.9996 14.7733 27.9996 14.0001C27.9996 13.227 27.3728 12.6001 26.5996 12.6001Z",
    fill: "#22C55E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.96 19.9396L21.9201 23.8997C22.1928 24.1732 22.5517 24.3099 22.9099 24.3099C23.2681 24.3099 23.6263 24.1732 23.8998 23.8997C24.4467 23.3529 24.4467 22.4663 23.8998 21.92L19.9397 17.96C19.3935 17.4131 18.5062 17.4131 17.96 17.96C17.4131 18.5061 17.4131 19.3934 17.96 19.9396Z",
    fill: "#22C55E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5996 26.6001C12.5996 27.3733 13.2265 28.0001 13.9996 28.0001C14.7728 28.0001 15.3996 27.3733 15.3996 26.6001V21.0001C15.3996 20.2269 14.7728 19.6001 13.9996 19.6001C13.2265 19.6001 12.5996 20.2269 12.5996 21.0001V26.6001Z",
    fill: "#22C55E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.08027 23.8997L10.0404 19.9396C10.5872 19.3934 10.5872 18.5062 10.0404 17.96C9.49414 17.4131 8.60689 17.4131 8.06067 17.96L4.10059 21.92C3.55371 22.4663 3.55371 23.3529 4.10059 23.8997C4.37402 24.1732 4.73223 24.3099 5.09043 24.3099C5.44863 24.3099 5.80749 24.1732 6.08027 23.8997Z",
    fill: "#22C55E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 14.0001C0 14.7733 0.626828 15.4001 1.4 15.4001H7C7.77312 15.4001 8.4 14.7733 8.4 14.0001C8.4 13.227 7.77312 12.6001 7 12.6001H1.4C0.626828 12.6001 0 13.227 0 14.0001Z",
    fill: "#22C55E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.08027 4.1001C5.53477 3.55322 4.64746 3.55322 4.10059 4.1001C3.55371 4.64697 3.55371 5.53357 4.10059 6.07979L8.06067 10.0399C8.3334 10.3133 8.69231 10.45 9.05052 10.45C9.40872 10.45 9.76763 10.3133 10.0404 10.0399C10.5872 9.49365 10.5872 8.6064 10.0404 8.06018L6.08027 4.1001Z",
    fill: "#22C55E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9996 8.4C14.7728 8.4 15.3996 7.77312 15.3996 7V1.4C15.3996 0.626828 14.7728 0 13.9996 0C13.2265 0 12.5996 0.626828 12.5996 1.4V7C12.5996 7.77312 13.2265 8.4 13.9996 8.4Z",
    fill: "#22C55E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_67137_11926"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkInProgressIcon);
export default __webpack_public_path__ + "static/media/WorkInProgressIcon.1c345320869ea295d6c0692f83688f4d.svg";
export { ForwardRef as ReactComponent };